import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function QualificationSection() {
  return <section className="bg-white py-20 px-4" data-id="element-161">
      <div className="max-w-5xl mx-auto" data-id="element-162">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-163">
          {/* Who is for */}
          <div className="bg-gray-light rounded-2xl p-8 border-t-8 border-green-500 shadow-md" data-id="element-164">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-navy mb-8 flex items-center" data-id="element-165">
              Esto ES para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-166">
              <li className="flex items-start" data-id="element-167">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-168" />
                <span className="text-text-dark text-lg" data-id="element-169">
                  Eres mujer latina de 40+ años que acaba de llegar a USA.
                </span>
              </li>
              <li className="flex items-start" data-id="element-170">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-171" />
                <span className="text-text-dark text-lg" data-id="element-172">
                  Llevas años aquí pero siempre has vivido pagando todo en
                  efectivo.
                </span>
              </li>
              <li className="flex items-start" data-id="element-173">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-174" />
                <span className="text-text-dark text-lg" data-id="element-175">
                  Eres madre que quiere ser co-firmante para sus hijos en el
                  futuro.
                </span>
              </li>
              <li className="flex items-start" data-id="element-176">
                <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-177" />
                <span className="text-text-dark text-lg" data-id="element-178">
                  Eres dueña de un pequeño negocio que necesita crédito
                  comercial pero no tiene crédito personal.
                </span>
              </li>
            </ul>
          </div>

          {/* Who is NOT for */}
          <div className="bg-gray-light rounded-2xl p-8 border-t-8 border-red-500 shadow-md" data-id="element-179">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-navy mb-8 flex items-center" data-id="element-180">
              Esto NO es para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-181">
              <li className="flex items-start" data-id="element-182">
                <XCircleIcon className="w-6 h-6 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-183" />
                <span className="text-text-dark text-lg" data-id="element-184">
                  Buscas trucos ilegales para borrar deudas reales.
                </span>
              </li>
              <li className="flex items-start" data-id="element-185">
                <XCircleIcon className="w-6 h-6 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-186" />
                <span className="text-text-dark text-lg" data-id="element-187">
                  No estás dispuesta a seguir un plan disciplinado de pagos.
                </span>
              </li>
              <li className="flex items-start" data-id="element-188">
                <XCircleIcon className="w-6 h-6 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-189" />
                <span className="text-text-dark text-lg" data-id="element-190">
                  Tienes juicios legales activos por fraude financiero.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}